

define(['angular', 'squid/index', 'xo-beaver/dist/logger', 'xo-device-info/dist/index'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xoAPayUtils', ['squid']).factory('$xoAPayUtils', function ($q, $logger, $DeviceInfo, $config, $http) {
        var _jwtToken = '';
        var _authenticated;

        // Call browser PaymentRequest API that returns a promise
        function createPaymentRequest() {
            var supportedInstruments = [{
                supportedMethods: ['https://android.com/pay'],
                data: {
                    minGooglePlayServicesVersion: '10400000',
                    paymentMethodTokenizationParameters: {
                        tokenizationType: 'GATEWAY_TOKEN',
                        parameters: {
                            gateway: 'paypal'
                        }
                    }
                }
            }];
            var details = {
                // Payment request requires an amount. Hardcode the value for now.
                total: { label: 'Checkout', amount: { currency: 'USD', value: '5.00' } }
            };

            var options = {};
            try {
                return new PaymentRequest(supportedInstruments, details, options); // eslint-disable-line no-undef
            } catch (e) {
                $logger.info('PAYMENT_REQUEST_NOT_SUPPORTED');
            }
        }

        function updateCookie(url, params) {
            $http({
                method: 'GET',
                url: url,
                params: params
            });
        }

        function isPaymentRequestAPISupported() {
            var currentVersionMatch = navigator.userAgent.match(/Chrome\/([0-9]+)\./i);
            return $DeviceInfo.isMobile() && window.navigator.vendor === 'Google Inc.' && 'PaymentRequest' in window && navigator.userAgent.match(/Android/i) && currentVersionMatch && Number(currentVersionMatch[1]) >= 58;
        }

        return {
            isAPayAPISupported: function isAPayAPISupported() {
                return isPaymentRequestAPISupported();
            },

            canMakeAPayPayment: function canMakeAPayPayment() {
                if (!isPaymentRequestAPISupported()) {
                    return $q.resolve(false);
                }

                var paymentRequest = window.appPaymentRequest || createPaymentRequest();

                if (paymentRequest && paymentRequest.canMakePayment) {
                    $logger.info('APAY_CHECK_CAN_MAKE_PAYMENT');
                    $logger.info('checkout_fpti', {
                        from: 'payment_request_check_payment',
                        to: 'prepare_payment_request_check_payment'
                    });

                    return paymentRequest.canMakePayment().then(function (result) {
                        if (result) {

                            $logger.info('APAY_CAN_MAKE_PAYMENT');
                            $logger.info('checkout_fpti', {
                                from: 'payment_request_check_payment',
                                to: 'process_payment_request_can_make_payment'
                            });
                            return true;
                        } else {
                            $logger.info('APAY_CAN_NOT_MAKE_PAYMENT_NO_PAYMENT');
                            $logger.info('checkout_fpti', {
                                from: 'payment_request_can_make_payment',
                                to: 'process_payment_request_can_not_make_payment',
                                error_source: 'PaymentRequestAPI',
                                error_type: 'no_payment'

                            });
                            return false;
                        }
                    })['catch'](function (err) {
                        $logger.info('APAY_CAN_NOT_MAKE_PAYMENT_SOFT_DECLINE', {
                            msg: err && err.message,
                            name: err && err.name
                        });

                        $logger.info('checkout_fpti', {
                            from: 'payment_request_can_make_payment',
                            to: 'prepare_payment_request_can_make_payment_soft_decline',
                            int_error_code: err && err.name,
                            int_error_description: err && err.message,
                            error_source: 'PaymentRequestAPI',
                            error_type: 'soft_decline'
                        });

                        return false;
                    });
                } else {
                    return $q.resolve(false);
                }
            },

            authenticateAPay: function authenticateAPay() {
                var forceAuthenticate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                if (!forceAuthenticate && _authenticated !== undefined) {
                    return $q.resolve(_authenticated);
                }

                _authenticated = false;
                _jwtToken = '';

                // Do not proceed if PaymentRequest is not supported.
                if (!isPaymentRequestAPISupported()) {
                    return $q.resolve(false);
                }

                var paymentRequest = window.appPaymentRequest || createPaymentRequest();
                if (paymentRequest) {
                    $logger.info('APAY_AUTHENTICATION_BEGIN');
                    $logger.info('checkout_fpti', {
                        from: 'payment_request_auth',
                        to: 'prepare_payment_request_auth'
                    });

                    return paymentRequest.show().then(function (result) {
                        result.complete('success');

                        $logger.info('APAY_AUTHENTICATION_SUCCEEDED');
                        $logger.info('checkout_fpti', {
                            from: 'payment_request_auth',
                            to: 'process_payment_request_auth',
                            param_type: 'JWT'
                        });

                        var paymentMethodToken = result.details && result.details.paymentMethodToken && JSON.parse(result.details.paymentMethodToken);
                        _jwtToken = paymentMethodToken.authJwt;
                        _authenticated = true;
                        return true;
                    })['catch'](function (err) {
                        $logger.info('APAY_AUTHENTICATION_FAILED', {
                            msg: err && err.message,
                            name: err && err.name
                        });

                        $logger.info('checkout_fpti', {
                            from: 'payment_request_auth',
                            to: 'process_payment_request_auth',
                            int_error_code: err && err.name,
                            int_error_description: err && err.message,
                            error_source: 'PaymentRequestAPI',
                            error_type: 'soft_decline'

                        });

                        return false;
                    });
                } else {
                    return $q.resolve(false);
                }
            },

            getAPayAuthToken: function getAPayAuthToken() {
                return _jwtToken;
            },

            setAPayCookie: function setAPayCookie(token) {
                if ($config.tokenizedWalletCookieURL) {
                    updateCookie($config.tokenizedWalletCookieURL, {
                        op: 'set',
                        token: token
                    });
                }
            },

            clearAPayCookie: function clearAPayCookie(token) {
                if ($config.tokenizedWalletCookieURL) {
                    updateCookie($config.tokenizedWalletCookieURL, {
                        op: 'clear',
                        token: token
                    });
                }
            },

            setOTAPayCookie: function setOTAPayCookie(token) {
                if ($config.tokenizedWalletCookieURL) {
                    updateCookie($config.tokenizedWalletCookieURL, {
                        op: 'setot',
                        token: token
                    });
                }
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/auth/lib/xoAPayUtils.js
// module id = ./components/xo-models/src/auth/lib/xoAPayUtils.js
// module chunks = 1